export const MOBILE_CRITEO_ID = 'trackTransactionApiMobile';
export const DESKTOP_CRITEO_ID = 'trackTransactionApiDesktop';
